<template>
	<div class="application-page">
		<b-container>
			<b-row>
				<b-col md="3">
					<Navigation page="sendoffs"/>
				</b-col>
				<b-col md="9">
					<h1>Verabschiedungen</h1>
					<SendoffsList
						type="application"
					/>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Navigation from "@/vue/application/profile/Navigation";
import SendoffsList from "@/vue/sendoff/List";

export default {

	components: {
		Navigation,
		SendoffsList,
	},
}
</script>
